/**
 * Static marketing content — Infopro Learning style landing sections.
 * Images live in src/assets/images/landing/
 */

import bannerAiWorkforce from '../../assets/images/landing/banner-ai-workforce.jpg';
import bannerAiLearning from '../../assets/images/landing/banner-ai-learning.jpg';
import bannerAiCoach from '../../assets/images/landing/banner-ai-coach.jpg';
import developTalent from '../../assets/images/landing/develop-talent.webp';
import empowerTeams from '../../assets/images/landing/empower-teams.webp';
import transformOrg from '../../assets/images/landing/transform-organization.webp';
import skillInferenceBanner from '../../assets/images/landing/skill-inference-banner.webp';
import personalizedBanner from '../../assets/images/landing/personalized-learning-banner.webp';
import aiAgentBanner from '../../assets/images/landing/ai-learning-agent-banner.jpg';
import skillsBasedModel from '../../assets/images/landing/skills-based-model.svg';
import skillInferenceIcon from '../../assets/images/landing/skill-inference-icon.svg';
import personalizedIcon from '../../assets/images/landing/personalized-learning-icon.svg';
import aiPoweredIcon from '../../assets/images/landing/ai-powered-icon.svg';

export const LEARNING_BANNERS = [
  {
    id: 'ai-era',
    image: bannerAiWorkforce,
    eyebrow: 'Human + AI',
    title: 'Workforce Transformation for the Human+AI Era',
    subtitle:
      'Upskill, adapt, and thrive — AI strategies every CLO, CHRO, and talent leader needs for 2026 and beyond.',
    ctaText: 'Book a Demo',
    ctaPath: '/enquiry',
  },
  {
    id: 'ai-learning',
    image: bannerAiLearning,
    eyebrow: 'AI-Powered Learning',
    title: 'AI Across Your Entire Learning Lifecycle',
    subtitle:
      'Skills inference, personalized journeys, and AI learning agents — built for performance-ready teams.',
    ctaText: 'Explore AI Learning',
    ctaPath: '/#ai-future',
  },
  {
    id: 'ai-coach',
    image: bannerAiCoach,
    eyebrow: 'AI Learning Agent',
    title: '24/7 AI Coaching in the Flow of Work',
    subtitle:
      'Intelligent assistants that guide learners, close skill gaps, and deliver on-demand practice when it matters most.',
    ctaText: 'Get Started',
    ctaPath: '/enquiry',
  },
];

export const WORKFORCE_TRANSFORMATION = {
  title: 'Workforce Transformation',
  description:
    "For over 30 years, we've been transforming the way organizations develop their most valuable asset — their people. As a comprehensive learning and talent consulting agency, we drive integrated development across individuals, teams, and organizations to build a performance-ready workforce.",
  pillars: [
    {
      title: 'Develop Talent',
      cta: 'Speed to Proficiency',
      image: developTalent,
      path: '/enquiry',
    },
    {
      title: 'Empower Teams',
      cta: 'Accelerate Growth',
      image: empowerTeams,
      path: '/enquiry',
    },
    {
      title: 'Transform Organization',
      cta: 'Amplify Business Agility',
      image: transformOrg,
      path: '/enquiry',
    },
  ],
};

export const AI_FUTURE = {
  title: 'AI-Powered Future of Learning & Development',
  subtitle: "We're integrating AI across your entire learning lifecycle.",
  items: [
    {
      id: 'skills-inference',
      title: 'Skills Inference',
      short:
        'AI-based inference to capture skills gaps for accurate training needs assessment.',
      body:
        'AI processes and analyzes data from diverse sources like performance reviews and project outcomes, employing AI-based inference to pinpoint current and projected skill gaps with precision. This advanced analysis enables the development of targeted, impactful training programs aligned with evolving organizational needs.',
      icon: skillInferenceIcon,
      image: skillInferenceBanner,
    },
    {
      id: 'personalized',
      title: 'Personalized Learning',
      short: 'Harnessing AI to craft tailored learning journeys.',
      body:
        'AI personalizes learning by analyzing individual data, offering tailored content and adaptive assessments. By leveraging AI, we help organizations create more effective and engaging training programs that adapt to each employee\'s unique learning journey.',
      icon: personalizedIcon,
      image: personalizedBanner,
    },
    {
      id: 'ai-agent',
      title: 'AI-Powered Learning Agent',
      short: 'Augmenting human expertise with AI-powered assistants.',
      body:
        'AI-powered virtual coaching uses intelligent chatbots for 24/7 learner support. These assistants handle inquiries, guide through concepts, facilitate role-plays, and provide practice scenarios. This approach enables personalized, on-demand learning experiences in the flow of work.',
      icon: aiPoweredIcon,
      image: aiAgentBanner,
    },
  ],
};

export const IMPACT_STATS = [
  { value: '10+', label: 'Years of Innovation' },
  { value: '10+', label: 'Industry Awards' },
  { value: '10K+', label: 'People Transformed' },
  { value: '100+', label: 'Programs Accelerating Skills' },
  { value: '10+', label: 'Enterprise Partners' },
];

export const SKILLS_BASED = {
  title: 'The Future is Skills-Based',
  eyebrow: 'End-to-End Workforce Transformation',
  description:
    'We enable organizations to thrive in the skills economy by reimagining workforce ecosystems, integrating skills, strategy, and systems to foster agile, high-impact organizations.',
  points: [
    'Aligning talent strategies with evolving skill requirements across the employee lifecycle.',
    'Seamlessly integrating talent acquisition, development, and deployment to ensure sustainable competitive advantage.',
    'Unlocking unprecedented organizational agility and performance.',
  ],
  tags: [
    'Succession Planning',
    'Employee Engagement and Retention',
    'Performance Management',
    'Onboarding and Upskilling',
    'Talent Acquisition',
  ],
  image: skillsBasedModel,
};

/** Kept for maintenance / inactive fallback */
export const HERO_FALLBACK = {
  title: 'Performance-Ready Workforce',
  subtitle:
    'Develop talent, empower teams, and transform organizations with AI-powered learning.',
  ctaText: 'Sign In',
  ctaUrl: '/login',
};
